// Subdomain detection: extracts gym slug from hostname.
// Returns null for: localhost, raw Firebase domains, root domain, www, app.
// Returns slug for: gymslug.mytrainforge.com, gymslug.localhost, etc.

const ROOT_HOSTNAMES = new Set([
  'mytrainforge.com',
  'www.mytrainforge.com',
  'app.mytrainforge.com',
  'localhost',
  'gearbox-staging.web.app',
  'gearbox-staging.firebaseapp.com',
  'gearbox-prod-47fd7.web.app',
  'gearbox-prod-47fd7.firebaseapp.com',
]);

export function getSubdomainGymSlug(hostname) {
  const host = hostname || (typeof window !== 'undefined' ? window.location.hostname : '');
  if (!host) return null;
  if (ROOT_HOSTNAMES.has(host)) return null;

  // Allow URL param override for local dev/testing: ?gym=gearbox-erie
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    const override = params.get('gym');
    if (override) return override;
  }

  // Extract subdomain prefix (first part before first dot)
  const parts = host.split('.');
  if (parts.length < 2) return null;

  const slug = parts[0];
  // Skip 'www' and 'app' as gym slugs
  if (slug === 'www' || slug === 'app') return null;
  return slug;
}

export function isMarketingSite(hostname) {
  const host = hostname || (typeof window !== 'undefined' ? window.location.hostname : '');
  return host === 'mytrainforge.com' || host === 'www.mytrainforge.com';
}
